module.exports = __webpack_public_path__ + "static/media/017.ff71aeb2.jpg";